import { UiMessageBubbleStoreContext } from "./_sotre/UiMessageBubbleStore";
import { useAtomValues } from "@deputy-ai/common/jotai";

export function UiMessageBubbleName() {
  const {
    propsAtoms,
    use: { uiNameVisible },
  } = UiMessageBubbleStoreContext.useStore();
  const { participantName } = useAtomValues(propsAtoms);

  if (!uiNameVisible) {
    return null;
  }

  return (
    <div className="text-primary-600 text-sm leading-none">
      {participantName}
    </div>
  );
}
